"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var wrapEvent = function (theirHandler, ourHandler) { return react_1.useCallback(function (e) {
    if (theirHandler) {
        theirHandler(e);
    }
    if (!e.defaultPrevented) {
        return ourHandler(e);
    }
}, [theirHandler, ourHandler]); };
exports.default = wrapEvent;
